import Linha from "./Linha";
import Quadrado from "./Quadrado";

export const Skeleton = {
  Linha,
  Quadrado,
};
